/**
 * Idempotent registration for `<fp-document-workspace>`.
 *
 * Safe to call repeatedly: a second call with the tag already taken is a no-op
 * rather than the DOMException `customElements.define` would otherwise throw.
 */
import { TAG_NAME } from '../constants/element';

import { DocumentWorkspaceElement } from './DocumentWorkspaceElement';

export function defineDocumentWorkspace(tagName: string = TAG_NAME): void {
  // No DOM, no point: keeps this a true no-op in SSR/build-time contexts,
  // same as before the history patch below existed.
  if (typeof customElements === 'undefined') return;

  // Installed here, not in connectedCallback: DSW's bootstrap calls this once
  // per page load, whereas the element itself is only mounted on some steps
  // of the flow (not Services/Preview) -- see _ensureHistoryPatched.
  DocumentWorkspaceElement._ensureHistoryPatched();

  if (customElements.get(tagName)) return;
  customElements.define(tagName, DocumentWorkspaceElement);
}
